const style = {
  span: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/BillingTable/style/ColorBlind/transaction.js